import gql from 'graphql-tag';

const updateEmail = gql`
  mutation updateEmail($email: String) {
    updateEmail(email: $email)
  }
`;

export default updateEmail;
